import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash-es';

import { Link } from 'site-modules/shared/components/link/link';
import { PriceDropAlertsBanner } from 'site-modules/profile/components/dashboard/price-drop-alerts-banner/price-drop-alerts-banner';
import { PriceDropAlerts } from 'site-modules/shared/components/profile/price-drop-alerts/price-drop-alerts';
import { getNewAlertsCountStatePath } from 'site-modules/shared/components/profile/price-drop-alerts/alerts-utils';

function InsiderNavigationLinkComponent({
  name,
  link,
  classes = '',
  showArrow = false,
  showPriceDropAlertsBanner = false,
  showNotification = false,
  savedItemsAmount = 0,
  newPriceDropAlertsCount = 0,
  selected = false,
}) {
  return (
    <Link to={link} className={classes} aria-current={selected ? 'page' : null}>
      {name}
      {savedItemsAmount > 0 && <span> {`(${savedItemsAmount})`}</span>}
      {showNotification && <PriceDropAlerts className="pos-r" hideCount />}
      {showArrow && <span className="insider-navigation-link-arrow text-info icon-arrow-right2 pe-0_5" aria-hidden />}
      {showPriceDropAlertsBanner && !!newPriceDropAlertsCount && (
        <div className="text-gray-darker fw-medium">
          <span className="icon-bell3 pe-0_25 text-warning" aria-hidden />
          <PriceDropAlertsBanner />
        </div>
      )}
    </Link>
  );
}

InsiderNavigationLinkComponent.propTypes = {
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  classes: PropTypes.string,
  showArrow: PropTypes.bool,
  showPriceDropAlertsBanner: PropTypes.bool,
  showNotification: PropTypes.bool,
  savedItemsAmount: PropTypes.number,
  newPriceDropAlertsCount: PropTypes.number,
  selected: PropTypes.bool,
};

export const mapStateToProps = state => ({
  newPriceDropAlertsCount: get(state, getNewAlertsCountStatePath()),
});

export const InsiderNavigationLink = connect(mapStateToProps)(InsiderNavigationLinkComponent);
